export const KORU_PRODUCT_SLUG = {
  'TRAINING_EXTENSION': 'training-extension',
  'PURCHASE_ANNUAL_PLAN': 'annual-subscription',
  'PURCHASE_STUDENT_APPS': 'student-apps',
};